import { useMemo } from 'react';
import useReportLog from './useReportLog';
import {
  calculateGpsSummary,
  formatGpsSummary,
  generateReportSummary,
} from '../screens/report/components/helperFunction';
import { EReportDataInterval } from '../screens/report/types/report-log.type';

/**
 * Summary of the loaded report log: the one of GET /report-log/summary,
 * calculated by the database over the minutes of the range, when it came with
 * the logs, otherwise calculated here from the logs (ramus2, migration).
 */
const useReportSummaryData = (range: {
  startAt: number;
  endAt: number;
  interval: EReportDataInterval;
  timezone?: number;
}) => {
  const { logs, reportSummary, speedUnit, distanceUnit, cruiseUnit } =
    useReportLog();

  const summary = useMemo<Record<string, any>>(
    () =>
      reportSummary ||
      generateReportSummary({
        startAt: range.startAt,
        endAt: range.endAt,
        interval: range.interval,
        logs,
        timezone: range.timezone,
      }),
    [
      reportSummary,
      logs,
      range.startAt,
      range.endAt,
      range.interval,
      range.timezone,
    ],
  );

  const gpsSummary = useMemo(() => {
    const units = { speedUnit, distanceUnit, cruiseUnit };
    return reportSummary
      ? formatGpsSummary(reportSummary.gps, units)
      : calculateGpsSummary(logs, units);
  }, [reportSummary, logs, speedUnit, distanceUnit, cruiseUnit]);

  return { summary, gpsSummary };
};

export default useReportSummaryData;
